import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { MAKE_SURE_YOU_GET_PAID, SET_UP_YOUR_ACCOUNT } from '../../constants';
import {
    getLocalizedDate,
    getLocalizedPayoutAmount,
    getNotificationMessage,
} from '../../utils';
import { NotificationMessageType } from '../../utils/types';

export const getPayoutMethodRequestEventEndedModalNotificationMessage = ({
    currency,
    endDate,
    eventName,
    locale,
    payoutAmount,
}: NotificationMessageType) => {
    const localizedPayoutAmount = getLocalizedPayoutAmount(
        locale,
        payoutAmount,
        currency,
    );
    const formattedEndDate = getLocalizedDate(endDate, locale);
    const description = (
        <>
            <p>
                {gettext(
                    'To receive your %(localizedPayoutAmount)s payout from your event that ended on %(formattedEndDate)s, add a bank account.',
                    {
                        localizedPayoutAmount,
                        formattedEndDate,
                    },
                )}
            </p>
            <p>
                {gettext(
                    "We can't deliver your funds until you add a bank account.",
                )}
            </p>
        </>
    );
    if (payoutAmount > 0) {
        const { title } = getNotificationMessage({
            currency,
            endDate,
            eventName,
            locale,
            payoutAmount,
        });
        return { title, description };
    }

    const title = MAKE_SURE_YOU_GET_PAID;

    return { title, description };
};

export const getFinancialMissingInformationModalNotificationMessage = ({
    currency,
    endDate,
    eventName,
    locale,
    payoutAmount,
}: NotificationMessageType) => {
    if (payoutAmount > 0) {
        const { title, description } = getNotificationMessage({
            currency,
            endDate,
            eventName,
            locale,
            payoutAmount,
        });
        return { title, description };
    }

    const title = MAKE_SURE_YOU_GET_PAID;
    const description = SET_UP_YOUR_ACCOUNT;

    return { title, description };
};
